import { api } from './http';

export interface DeadlineCard {
  deadline_id: number;
  matter_id: number;
  matter_name: string;
  deadline_type: string;
  deadline_type_label: string;
  category: string;
  buckets: string[];
  title: string;
  display_title: string;
  deadline_date: string;
  days_until: number;
  urgency: string;
  is_overdue: boolean;
  url: string;
}

export interface BulletinNote {
  id: number;
  column_id: number;
  title: string | null;
  body: string | null;
  color: string | null;
  matter_id: number | null;
  matter_title: string | null;
  position: number;
  created_by_id: number | null;
  updated_by_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface BulletinColumn {
  id: number | string;              // string ids are reserved for future virtual columns
  title: string;
  kind: 'deadlines' | 'notes';
  deadline_filter: string | null;
  position: number;
  is_virtual: boolean;
  updated_at: string | null;
  cards: DeadlineCard[];
  notes: BulletinNote[];
}

export interface BulletinBoard {
  enabled: boolean;
  columns: BulletinColumn[];
}

export const getBoard = () =>
  api.get<BulletinBoard>('/bulletin/board').then(r => r.data);

export const getBulletinEnabled = () =>
  api.get<{ enabled: boolean }>('/bulletin/enabled').then(r => r.data);

export const setBulletinEnabled = (enabled: boolean) =>
  api.patch<{ enabled: boolean }>('/bulletin/settings', { enabled }).then(r => r.data);

export const createColumn = (data: { title: string; kind: 'notes' }) =>
  api.post<BulletinColumn>('/bulletin/columns', data).then(r => r.data);

export const patchColumn = (id: number, data: { title?: string; deadline_filter?: string | null; position?: number; expected_updated_at?: string }) =>
  api.patch<BulletinColumn>(`/bulletin/columns/${id}`, data).then(r => r.data);

export const deleteColumn = (id: number) =>
  api.delete(`/bulletin/columns/${id}`).then(r => r.data);

export const createBulletinNote = (data: { column_id: number; title?: string | null; body?: string | null; color?: string | null; matter_id?: number | null }) =>
  api.post<BulletinNote>('/bulletin/notes', data).then(r => r.data);

export const patchNote = (id: number, data: { title?: string | null; body?: string | null; column_id?: number; position?: number; expected_updated_at?: string; color?: string | null; matter_id?: number | null }) =>
  api.patch<BulletinNote>(`/bulletin/notes/${id}`, data).then(r => r.data);

export const deleteBulletinNote = (id: number) =>
  api.delete(`/bulletin/notes/${id}`).then(r => r.data);
